<template>
<div class="animated fadeIn mt-5">
  <loading v-if="loading"></loading>
  <form v-if="!loading" enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <div class="col-md-8">
        <b-card>
          <div slot="header">
            <strong>Quota</strong>
          </div>
            <modal-select label="Família" namevar="surname" modal="families-modal" v-validate="'required'" name="family_id" v-bind:readonly="item.id>0" v-bind:item-id="item.family_id" v-bind:item-code="item.family.data.code"  v-bind:item-name="item.family.data.surname" v-on:select-item="selectFamily"  :state="validateState('family_id')"  ></modal-select>

            <b-form-fieldset label="Estado">
              <b-form-select v-model="item.state" :options="states.feeStates" class="mb-3">
              </b-form-select>
            </b-form-fieldset>
            <b-row>
              <b-col md="3" >
                <b-form-fieldset label="Ano">
                  <b-form-input type="text" name="fee_year" v-model="item.fee_year" placeholder="Ano" v-validate="{ required: true }" :state="validateState('fee_year')" data-vv-validate-on="change" ></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('fee_year') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
              </b-col>
              <b-col md="3" >
                <b-form-fieldset label="Valor">
                  <b-form-input type="text" name="fee_value" v-model="item.fee_value" placeholder="Valor" v-validate="{ required: true }" :state="validateState('fee_value')" data-vv-validate-on="change" ></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('fee_value') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
              </b-col>
              <b-col md="3" >
                <b-form-fieldset label="Valor Pago">
                  <b-form-input type="text" name="paid_value" v-model="item.paid_value" placeholder="Valor Pago" v-validate="{ required: true }" :state="validateState('paid_value')" data-vv-validate-on="change" ></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('paid_value') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
              </b-col>
              <b-col md="3" >
                <b-form-fieldset label="Data Pago">
                  <b-form-input type="text" name="paid_at" v-model="item.paid_at" placeholder="Data Pago" v-validate="{ required: false }" :state="validateState('paid_at')" data-vv-validate-on="change" ></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('paid_at') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
              </b-col>

            </b-row>



          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:baseRoute + '.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <!--/.col-->
      <div class="col-md-4">
        <b-card>
          <div slot="header">
            <strong>Referências MB</strong>
          </div>

          <b-table striped hover :items="item.references.data" :fields="referencesFields">
            <template v-slot:cell(state)="data">
              {{ states.translate(data.value, 'referenceStates') }}
            </template>
          </b-table>

          <b-form-fieldset description="Caso existam, as referências atuais irão ser canceladas e criadas novas referências" label="Gerar novas referências">
            <b-form-select v-model="generateMB" :options="states.yesNo" class="mb-3">
            </b-form-select>

          </b-form-fieldset>
        </b-card>
      </div>
      <!--/.col-->
    </div>
  </form>

</div>
</template>

<script>
import States from '@/components/Lists.js'
export default {
  name: 'feesEdit',
  props: ['id'],
  data() {
    return {
      url: 'fees',
      baseRoute: 'fees',
      states: States,
      loading: true,
      generateMB: 0,
      item: {
        fee_year: null,
        fee_value: null,
        paid_value: null,
        paid_at: null,
        state: null,
        family_id: null,
        family: {
          data: {
          }
        },
        references: {
          data: []
        }
      },
      referencesFields: [{
        key: 'state',
        label: 'Estado',
        sortable: true
      }, {
        key: 'entity',
        label: 'Entidade',
        sortable: true
      }, {
        key: 'reference',
        label: 'Referência',
        sortable: true
      }, {
        key: 'value',
        label: 'Valor',
        sortable: true
      }, {
        key: 'expiration_date',
        label: 'Data limite',
        sortable: true
      }]
    }
  },
  methods: {
    selectFamily(e) {
      if(e.item) {
        console.log(e.item)
        this.item.family_id = e.item.id
        this.item.family.data = e.item
      } else {
        this.item.family_id = null
        this.item.family.data = {id: null, surname:null}
      }
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast('Tem campos inválidos', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      data.data.generateMB = this.generateMB
      if (this.item.id) {
        this.axios.put(this.url + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
            if (close) {
              this.$router.push({
                name: this.baseRoute + '.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast('Não foi possivel gravar', { autoHideDelay: 5000, variant: 'danger', solid: true})
          })
      } else {
        this.axios.post(this.url, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
            this.$router.push({
              name: this.baseRoute + '.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast('Não foi possivel gravar', { autoHideDelay: 5000, variant: 'danger', solid: true})
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get(this.url + '/' + id)
        .then(response => {
          this.item = response.data.data
          this.loading = false
        })
        .catch(response => {
          this.$bvToast.toast('Este histórico não existe', { autoHideDelay: 5000, variant: 'danger', solid: true})
          this.$router.push({
            name: this.baseRoute + '.index'
          })
        })
    } else {
      this.loading = false
    }
  }
}
</script>
